import { z } from 'zod'

import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

const FeedbackSchema = z.object({
  total_records: z.number(),
  records: z.array(
    z.object({
      assignment_id: z.string(),
      assignment_code: z.number().optional(),
      feedback_by: z
        .object({
          id: z.string(),
          full_name: z.string(),
          first_name: z.string(),
          last_name: z.string(),
          display_name: z.string().nullable(),
          avatar: z.string().nullable()
        })
        .optional(),
      client: z
        .object({
          id: z.string(),
          company_name: z.string(),
          company_website: z.string().nullable()
        })
        .optional(),
      rating: z.number().nullable(),
      feedback_text: z.string(),
      feedback_type: z.string(),
      feedback_tag_type: z
        .object({
          id: z.number(),
          is_positive_tag: z.number(),
          key: z.string(),
          title: z.string()
        })
        .nullable()
        .optional(),
      created_at: z.string()
    })
  )
})

export type Feedback = z.infer<typeof FeedbackSchema>
export type FeedbackItem = Feedback['records'][number]

export const getFeedbacks = async (
  userId: string
): Promise<ApiResponseV2<Feedback>> => {
  try {
    const response = await axios.get<Feedback>(`/users/${userId}/feedback`)

    FeedbackSchema.parse(response.data)

    return extract.data<Feedback>(response)
  } catch (error) {
    return extract.error(error)
  }
}
